export default __webpack_public_path__ + "static/media/psb.7135b120.svg";